import { Injectable, Inject} from '@angular/core';

export class QuotationPremiumSummaryDO {

	private  id:Number;

	public  getId():Number {
		return this.id;
	}
}